import * as Turbo from "@hotwired/turbo";

Turbo.session.drive = false;
